import Radio from '@material-ui/core/Radio';

import useStyles from './styles';

function TwRadio(props) {
  const classes = useStyles();
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Radio classes={classes} color="primary" {...props} />;
}

export default TwRadio;
